import { INSIGHT_CUBE_NAME } from '@/api/hcp/interaction/types';
import { INSIGHT_DATE_DIMENSION } from '@/pages/Insights/constants';
import { FilterConfigDynamic } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { FilterLimitPresets } from '../../filterDefaultLimits';
import { isNonEmptyStringArray } from '../../utils';
import mapDimensionToOption from '../../utils/mapDimensionToOption';

const DIMENSION = `${INSIGHT_CUBE_NAME}.created_by_employee`;

const RESTRICTED_COUNTRIES = new Set(['AT', 'DE']);

const insightEmployeeNameFilter: FilterConfigDynamic = {
  label: 'main.insights.filters.labels.employeeName',
  placeholder: 'main.insights.filters.labels.employeeName',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  useFloatingLabel: true,
  hidden: ({ contexts }) => {
    const countries = contexts.userInfo?.countries ?? [];
    return countries.length > 0 && countries.every(country => RESTRICTED_COUNTRIES.has(country));
  },
  sourceCube: INSIGHT_CUBE_NAME,
  getOptionsQuery: ({ dateRange }) => ({
    dimensions: [DIMENSION],
    limit: FilterLimitPresets.LIMIT_5K,
    timeDimensions: [getDateRangeTimeDimension({ dateRange, dimension: INSIGHT_DATE_DIMENSION })],
  }),
  mapResult: mapDimensionToOption(DIMENSION),
  applyFilter: value => {
    if (!isNonEmptyStringArray(value)) return undefined;

    return {
      member: DIMENSION,
      operator: 'equals',
      values: value,
    };
  },
};

export default insightEmployeeNameFilter;
